import React from 'react';
import { Col, Row, FloatButton } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {
  Card,
  Icon,
  Input,
  Modal,
  ProjectCard,
  Select,
  Upload,
} from '../../components';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createProject, getProjects } from '../Dashboard/actions';
import { IsWeb } from '../../components/basics/Platform';


const Projects = () => {
  const [modalVisible, setModalVisible] = React.useState(false);
  const [name, setName] = React.useState('');
  const [logo, setLogo] = React.useState('');
  const [members, setMembers] = React.useState([]);
  const [filterType, setFilterType] = React.useState(1);
  const projects = useSelector((s) => s.dashboard.projects);
  const user = useSelector((s) => s.auth.user.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const IsWebView = IsWeb();

  React.useEffect(() => {
    dispatch(getProjects());
  }, []);

  const createProjectFunc = React.useCallback(() => {
    if (!projects.creating && name)
      dispatch(createProject({ logo, name, members, navigate }));
  }, [logo, name, members, projects]);

  const optsList = React.useMemo(
    () => [
      { value: 1, label: 'Active Journeys' },
      { value: 2, label: 'Archived Journeys' },
    ],
    []
  );

  return (
    <div className="projects">
      <div className="heading">
        <h1>Woosla</h1>
        <h4>Journeys</h4>
      </div>
      <Select
        value={filterType}
        onChange={setFilterType}
        options={optsList}
        className="filterSelect"
      />
      <Row gutter={20}>
        {IsWebView ? (
          <Col xs={24} md={12} lg={8}>
            <div className="createBlock" onClick={() => setModalVisible(true)}>
              <Icon name="plus-circle" size={40} />
              <h3>New Journey</h3>
            </div>
          </Col>
        ) : null}
        {projects.loading
          ? [1, 2, 3].map((x) => (
              <Col xs={24} md={12} lg={8} key={x}>
                <Card loading minHeight={200} />
              </Col>
            ))
          : projects.data
              .filter((p) => (filterType === 2 ? p.archived : !p.archived))
              .map((item) => (
                <Col xs={24} md={12} lg={8} key={item._id}>
                  <ProjectCard data={item} />
                </Col>
              ))}
      </Row>

      <Modal
        title="New Journey"
        visible={modalVisible}
        onOk={createProjectFunc}
        okText="Create"
        onCancel={() => setModalVisible(false)}
      >
        <div className="align-center">
          <Upload
            listType=""
            preview={logo && URL.createObjectURL(logo)}
            onChange={(e) => setLogo(e.file)}
            accept="image/png, image/gif, image/jpeg"
          />
        </div>
        <div className="space" />
        <Input value={name} onChange={setName} placeholder="Journey Name" />
        <Select
          value={members}
          placeholder={'Members'}
          onChange={setMembers}
          mode="multiple"
          options={user.contacts.map((m) => ({
            value: m._id,
            label: m.firstName + ' ' + m.lastName,
          }))}
        />
      </Modal>

      {IsWebView ? null : (
        <FloatButton
          style={{
            // width: 50,
            // height: 50,
            justifyContent: 'center',
            alignItems: 'center',
          }}
          onClick={() => setModalVisible(true)}
          icon={<PlusOutlined style={{ color: '#AD64C6' }} />}
          tooltip={<div>New Journey</div>}
          type={'default'}
        />
      )}
    </div>
  );
};

export default Projects;
